'use strict';

var withStyles = require('../../Styles/withStyles.js');
var colorManipulator = require('../../../node_modules/@material-ui/core/esm/styles/colorManipulator.js');
var InputBase = require('../../../node_modules/@material-ui/core/esm/InputBase/InputBase.js');

var FlatInput = withStyles["default"](function (theme) {
  return {
    root: {
      color: theme.palette.secondary.main,
      '&:hover': {
        background: colorManipulator.fade(theme.palette.secondary.main, theme.palette.action.hoverOpacity)
      },
      '&$focused': {
        background: colorManipulator.fade(theme.palette.secondary.main, theme.palette.action.focusOpacity)
      },
      '& $input:focus, & $input:hover': {
        background: 'transparent'
      },
      padding: '4px 8px',
      borderRadius: 4
    },
    input: {},
    focused: {}
  };
})(InputBase["default"]);

module.exports = FlatInput;
